import React from 'react';
import './Loader.css';

/**
 * Loading spinner component with optional message.
 * Uses centralized spinner classes from utils.css
 *
 * @param {object} props
 * @param {string} [props.message] - Message to display below the spinner.
 * @param {boolean} [props.isOverlay] - If true, shows loader as fullscreen overlay.
 */
const Loader = ({ message, isOverlay = false }) => {
  return (
    <div className={`loader ${isOverlay ? 'loader--overlay' : ''}`}>
      <div className="loader-content">
        <div className="spinner-circle spinner-circle--xl"></div>
        {message && <p className="loader-message">{message}</p>}
      </div>
    </div>
  );
};

export default Loader;